/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc factory
 * @name HealthScoreMetric
 * @description
 *
 *     Health score series is fetched through GET API requests, therefore we don't extend
 *     CollMetric here. Besides that, 1. it doesn't support realtime timeframe, meaning steps can't
 *     be smaller than five minutes. 2. the UI polling interval is always 30s regardless of what's
 *     set in the selected timeframe config, as there might be state changes. i.e. VS/Pool/Server
 *     could go down and this impact the calculation of HS.
 *
 * @author Alex Malitsky, Zhiqian Liu
 */
angular.module('aviApp').factory('HealthScoreMetric', [
'Metric', 'Timeframe',
function(Metric, Timeframe) {
    return class HealthScoreMetric extends Metric {
        constructor(args = {}) {
            const seriesName = 'health_score';

            args.name = args.name || seriesName;
            args.series = args.series || [seriesName];

            super(args);
        }

        /** @override */
        beforeCall() {
            const reqConfigs = super.beforeCall();

            if (!reqConfigs) {
                return null;
            }

            const
                { series: config } = reqConfigs,
                { key: tfKey } = Timeframe.selected();

            // real time is not supported by health score API, still getting 30 minutes
            if (tfKey === 'rt') {
                const { params } = this;
                const step = 300;
                const limit = 6;

                params.step = step;
                config.step = step;
                params.limit = limit;
                config.limit = limit;
            }

            return reqConfigs;
        }

        /** @override */
        requestConfig() {
            return true;
        }

        /** @override */
        afterCall(resp) {
            return super.afterCall(resp && resp['series']);
        }

        /**
         * @override
         * When param frequency defaults, HS metrics would always set interval to 30s regardless of
         * timeframe selected.
         * @return {number}
         * @protected
         */
        getUpdatePeriod_() {
            const { frequency } = this.params;
            let period;

            if (angular.isFunction(frequency)) {
                period = frequency();
            } else {
                period = frequency;
            }

            if (!angular.isNumber(period)) {
                period = 30;
            }

            return period;
        }
    };
}]);
